<span dropdown #fontSizeDropdown="bs-dropdown" container="body">
  <a href id="font-size" (click)="dropdownClick()" dropdownToggle aria-controls="font-size-dropdown"
    class="dropdown-toggle" [ngClass]="applyAnchorCss()">Text Size
    <span class="caret"></span>
</a>
<ul id="font-size-dropdown" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="font-size">
    <li class="nav-item">
        <a href="javascript:void(0)" id="font-small" class="dropdown-item fontsResize selected small" font-class="small" set-font from-login="true" (click)="setFontSize('small')">Small</a>
    </li>
    <li class="divider dropdown-divider"></li>
    <li class="nav-item">
        <a href="javascript:void(0)" id="font-normal" class="dropdown-item fontsResize selected normal" font-class="normal" set-font from-login="true" (click)="setFontSize('normal')">Normal</a>
    </li>
    <li class="divider dropdown-divider"></li>
    <li class="nav-item">
        <a href="javascript:void(0)" id="font-large" class="dropdown-item fontsResize selected large" font-class="bigger" set-font from-login="true" (click)="setFontSize('large')">Large</a>
    </li>
</ul>
</span>